<template>
    <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="title" data-aos="fade-up">BioVision生物样本库数字孪生大屏可视化系统</div>
            <div class="content" data-aos="fade-up">
              BioVision 生物样本库数字孪生大屏可视化系统，可实时、直观且精准地展示生物样本库动态运行数据与关键业务指标，辅助管理人员开展决策，支撑业务统一指挥与资源及时调度。
            </div>
            <div class="content" data-aos="fade-up">
              系统依托数字孪生技术，完成实物系统运行数据与虚拟系统的映射关联，构建可视化信息展示界面，实时监测呈现样本库整体运行状况、关键设备性能、样本存储状态等信息，帮助管理人员实现问题的快速判定与定位。系统支持根据客户业务需求定制开发，可扩展关键设备参数实时监测、库房空间三维模拟展示等功能，更好适配用户管理需求，满足业务发展的个性化要求。
            </div>
            <div class="content" data-aos="fade-up">
              作为生物样本库智慧运维的重要技术手段，系统实现生物样本库运行全过程动态监控、预警及预测，助力降低管理风险，提升生物样本库运行稳定性与安全管控能力，优化样本库运营管理水平。
            </div>
            <div class="pic">
                <img :src="require('@/assets/img/products/bioVision/content1.png')" alt="" data-aos="zoom-in">
                <img :src="require('@/assets/img/products/bioVision/content2.png')" alt="" data-aos="zoom-in">
                <img :src="require('@/assets/img/products/bioVision/content3.png')" alt="" data-aos="zoom-in">
                <img :src="require('@/assets/img/products/bioVision/content4.png')" alt="" data-aos="zoom-in">
            </div>
        </div>
    </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
    name:'BioVision',
    components: {ProductsMenu},
    data(){
      return {

      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
        background: url("../../assets/img/products/bioVision/contentBg.png") no-repeat;
        padding-top: 100px;
        padding-bottom: 120px;
        margin-top: 20px;
    }
    .title{
        font-size: 36px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 47px;
        letter-spacing: 0px;
        color: #ed1d25;
        margin-left: 15%;
        margin-bottom: 43px;
    }
    .content{
        width: 960px;
        font-family: SourceHanSansCN-Regular;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #333333;
        margin-left: 8%;
        text-indent: 2em;
    }
    .pic{
        width: 1011px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: 7%;
        margin-top: 115px;
        img{
            width: 494px;
            margin-bottom: 30px;
        }
    }
</style>
